import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import HrAlertsPage from './HrAlertsPage';
import RecruitmentPage from './RecruitmentPage';
import TrainingPage from './TrainingPage';
import EvaluationsPage from './EvaluationsPage';
import LeavesPage from './LeavesPage';
import EmployeeContractsPage from './EmployeeContractsPage';
import HRConfigPage from './HRConfigPage';
import HrAnalysesRapportsPage from './HrAnalysesRapportsPage';
import HrDashboardPage from './HrDashboardPage';

/**
 * HR module shell — routes aligned with saudiModuleStructure.js (Unit 11).
 * Paths: /hr/dashboard, /hr/recruitment, /hr/leaves, /hr/contracts,
 *        /hr/analyses-rapports, /hr/config, /hr/alertes
 * Departures/sanctions/accidents remain top-level routes in FeatureAwareRouter.
 */
const HrMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.ressources_humaines.pages.hrMainPage.${key}`, opts);

  return (
    <div className="space-y-6" aria-label={p('title')}>
      <span className="sr-only">{p('subtitle')}</span>
      <Routes>
        <Route path="/" element={<Navigate to="/hr/dashboard" replace />} />
        <Route path="/dashboard" element={<HrDashboardPage />} />
        <Route path="/alertes" element={<HrAlertsPage />} />
        <Route path="/recruitment" element={<RecruitmentPage />} />
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/evaluations" element={<EvaluationsPage />} />
        <Route path="/leaves" element={<LeavesPage />} />
        <Route path="/contracts" element={<EmployeeContractsPage />} />
        <Route path="/analyses-rapports" element={<HrAnalysesRapportsPage />} />
        <Route path="/config" element={<HRConfigPage />} />
        <Route path="*" element={<Navigate to="/hr/dashboard" replace />} />
      </Routes>
    </div>
  );
};

export default HrMainPage;
